/**
 * @file A proven cell or fact as it reads on the field it lands on: its
 * `checks` plus the `roleChecks` staged for that field's role. The one place
 * the lighting checks meet the effective mapping, so a column the reviewer
 * remaps off a `cct` field stops failing `allowedValues` and a column remapped
 * onto `quantity` is checked as one. No role, or no staged checks for it,
 * returns the cell unchanged. Pure. Consumers: `stagedScheduleFields` (routing
 * and the approval gate) and S2's `scheduleReviewTables`.
 */
import type { ExtractionFieldRole } from './System.Agent.Extraction.types';
import type { SourceCell, SourceFact } from './System.Agent.PdfEvidence.types';

export function withRoleChecks<T extends SourceCell | SourceFact>(cell: T, role: ExtractionFieldRole | undefined): T {
  const extra = role ? cell.roleChecks?.[role] : undefined;
  return extra && extra.length > 0 ? { ...cell, checks: [...cell.checks, ...extra] } : cell;
}
